/**
 * NewItemsBanner — Banner inline mostrando contagem de novos itens recebidos via SSE
 * desde o ultimo refetch. Click -> refetch + scroll-to-top.
 *
 * Mantine `<Notification>` simples (sem `<Affix>` que cobre o body em mobile).
 */
import { Notification } from '@mantine/core'
import { IconBellRinging } from '@tabler/icons-react'

interface Props {
  count: number
  onShow: () => void
}

export function NewItemsBanner({ count, onShow }: Props) {
  if (count <= 0) return null
  return (
    <Notification
      icon={<IconBellRinging size={18} />}
      color="blue"
      title={`${count} ${count === 1 ? 'nova notificação' : 'novas notificações'}`}
      withCloseButton={false}
      onClick={onShow}
      style={{ cursor: 'pointer' }}
    >
      Clique para atualizar o feed.
    </Notification>
  )
}
